module.exports = __webpack_public_path__ + "static/media/bg.a34b8935.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.mp4
// module id = 160
// module chunks = 0